<template>
    <v-container fluid>
        <v-row class="mt-0 mb-0 py-0">
            <v-col cols="12" align="center" class="py-0 my-0">
                <article-card :article="articles[0]" :main="true" />
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="(article, index) in articles.slice(1)" :key="index" cols="12" md="6">
                <article-card :article="article" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ArticleCard from '@/components/ArticleCard'
    import articleService from '@/services/article'

    export default {
        components: { ArticleCard },
        data() {
            return {
                page: 1,
                size: 7,
                totalPages: 0,
                articles: [],
                loading: false,
                scrollHandler: null
            }
        },
        created() {
            this.fetchArticles()
        },
        mounted() {
            this.attachScrollHandler()
        },
        beforeDestroy() {
            this.detachScrollHandler()
        },
        methods: {
            goToArticle(article) {
                this.$router.push({ name: 'Article', params: { id: article.id } })
            },
            getArticleImage() {
                return `${'https://storage.googleapis.com'}/${this.articles[0].image}`
            },
            attachScrollHandler() {
                // Create a stable handler so we can remove it later
                if (this.scorllHandler) return
                this.scorllHandler = () => {
                    // small threshold so near-bottom loads too
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0
                    const windowHeight = window.innerHeight
                    const docHeight = document.documentElement.scrollHeight
                    const threshold = 200 // px from bottom
                    if (scrollTop + windowHeight >= docHeight - threshold) {
                        // load next page if available and not already loading
                        if (!this.loading && this.page < this.totalPages) {
                            this.page += 1
                            this.fetchArticles()
                        }
                    }
                }
                window.addEventListener('scroll', this.scorllHandler, { passive: true })
            },
            detachScrollHandler() {
                if (this.scorllHandler) {
                    window.removeEventListener('scroll', this.scorllHandler)
                    this.scorllHandler = null
                }
            },
            fetchArticles() {
                if (this.loading) return
                this.loading = true
                articleService.getArticles(this.page, this.size)
                    .then(resp => {
                        if (Array.isArray(resp.data.content) && resp.data.content.length > 0) {
                            this.articles.push(...resp.data.content)
                        }
                        this.totalPages = resp.data.totalPages
                    })
                    .catch(err => {
                        // optionally log error
                        console.error('fetchArticles error', err)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    }
</script>
